"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLES = exports.DEPARTMENTS = exports.TABLE_HEAD_CELLS = void 0;
exports.TABLE_HEAD_CELLS = [
    {
        name: "Name",
    },
    {
        name: "Area",
        align: "left",
    },
    {
        name: "E-mail",
        align: "left",
    },
    {
        name: "Roles",
        align: "left",
    },
    {
        name: "",
    },
];
exports.DEPARTMENTS = new Map([
    ["planning_and_scheduling", "Planning and Scheduling"],
    ["process_engineering", "Process Engineering"],
    ["feedstock_trading", "Feedstock Trading"],
]);
exports.ROLES = new Map([
    ["planner", "Planner"],
    ["admin", "Admin"],
    ["trader", "Trader"],
    ["engineer", "Engineer"],
]);
